import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, CSSProperties, onMounted, ref, watch } from "vue";
import { useFormValidator, FormValidators } from "tir-pm-form-validation";
import {
  MenuBreadcrumbs,
  SettingsBreadcrumbsModel,
  MenuBreadcrumbsColorEnum,
} from "@/components/menu-breadcrumbs";
import {
  TirPmDrawer,
  TirPmDrawerPositionEnum,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmScrollbar,
  TirPmIconView,
  TirPmPlate,
  TirPmStatusBudge,
  TirPmInput,
} from "tir-components";
import { ArrowsPointingOutIcon, EllipsisHorizontalIcon } from "tir-style-system/icons/outline";

import { CurrentUser, CurrentUserModel } from "tir-pm-user-core";
import { useRoute, useRouter } from "vue-router";
import {
  ITextEditorFile,
  TirPmTextEditorFile,
  TirPmTextEditorFilePreview,
} from "tir-pm-texteditor-file";
import {
  TirPmNotificationEventBus,
  TirPmNotificationGroup,
  TirPmNotificationModel,
} from "tir-pm-notification";

import { GroupModel, NamespaceModel, QueueTasksModel } from "@/components/sidebar/models";
import { TaskDrawerSettingsModel } from "@/components/task-forms";


export default /*#__PURE__*/_defineComponent({
  __name: 'namespace-drawer',
  props: {
  /**Скрыть кнопку перехода на детальную страницу */
  hideDetailButton: {
    type: Boolean,
    default: false,
  },
},
  emits: ["subtaskItem", "removeSubtaskItem"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const router = useRouter();




const isShowMessage = ref(false);

/**Раскрыто ли полностью описание */
const isExpandDescription = ref(false);

function onUpdateVisible(value) {
  visible.value = value;
}

/**ID очереди */
const queueId = ref<string>();
/**ID проекта */
const projectId = ref<number>();

/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    "add",
    new TirPmNotificationModel({
      title: message,
      type: isError ? "error" : "success",
      group: "namespace-drawer",
      life: life ?? 2000,
      closable: true,
    }),
  );
};

const route = useRoute();

/**Были ли проинициализированны даты */
let isInitedData = false;
/**Загрузка при инициализации */
const isInitLoading = ref(false);

/**Видимость tir-pm-drawer */
const visible = ref(false);

/**
 * Открыть шторку
 * @param settings Настройки открытия шторки
 */

const open = async () => {
  visible.value = true;
};

__expose({
  open,
  close: () => onUpdateVisible(false),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", { open: open }),
    _createVNode(_unref(TirPmDrawer), {
      visible: visible.value,
      size: "51.875rem",
      position: _unref(TirPmDrawerPositionEnum).Right,
      "onUpdate:visible": onUpdateVisible
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(TirPmNotificationGroup), {
          group: "namespace-drawer",
          position: "top-right",
          zIndex: 20000
        }),
        _createVNode(_unref(TirPmInput), {
          modelValue: _ctx.queueName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.queueName) = $event)),
          label: "Название очереди",
          placeholder: "Новая очередь",
          "is-with-error": !!_ctx.errorMessage,
          "is-show-hint": !!_ctx.errorMessage
        }, {
          hintMessage: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "is-with-error", "is-show-hint"]),
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
          size: _unref(TirPmButtonSizeEnum).Small,
          onClick: _ctx.onClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Сохранить ")
          ]),
          _: 1
        }, 8, ["variant", "size", "onClick"])
      ]),
      _: 1
    }, 8, ["visible", "position"])
  ], 64))
}
}

})